import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchOrderStatus, updateOrderStatus } from "actions/orderStatus";

import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/OrderStatus/Form";

class OrderStatusEdit extends Component {
  componentDidMount() {
    const { match, fetchOrderStatus } = this.props;
    const id = match.params.orderStatusId;
    fetchOrderStatus(id);
  }

  shapedDefaultValuesStructure() {
    const { ...rest } = this.props.orderStatus.data;

    return Object.assign(
      {},
      {
        ...rest
      }
    );
  }

  updateOrderStatus(id, data) {
    const { toggleNotification, toggleFullPageSpinner, updateOrderStatus, history } = this.props;

    toggleFullPageSpinner(true);

    updateOrderStatus(id, data)
      .then(() => {
        toggleNotification(true, { message: "Updated OrderStatus Success", infoClassName: "is-success" });
        history.push(`/order-status`);
      })
      .catch(e => {
        toggleNotification(true, { message: e.message, infoClassName: "is-danger" });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  handleFormSubmit = data => {
    const id = this.props.match.params.orderStatusId;

    this.updateOrderStatus(id, data);
  };

  render() {
    const { orderStatus } = this.props;

    if (orderStatus.loading) {
      return "loading";
    }
    const defaultValues = this.shapedDefaultValuesStructure();
    return <Form handleFormSubmit={this.handleFormSubmit} defaultValues={defaultValues} />;
  }
}

const mapStateToProps = ({ orderStatus }) => ({
  orderStatus
});

export default connect(
  mapStateToProps,
  {
    fetchOrderStatus,
    updateOrderStatus,
    toggleFullPageSpinner,
    toggleNotification
  }
)(OrderStatusEdit);



// WEBPACK FOOTER //
// ./src/pages/OrderStatus/Edit/index.js